import RelatedPagesComponent from "../../../../components/help/RelatedPagesComponent.tsx";
import QuestionAnswerComponent, {Question} from "../../../../components/help/QuestionAnswerComponent.tsx";
import {Link} from "react-router-dom";
import {imageMap} from "../../../../images/imageMap.ts";
import {ALL_FIBER, BigCoverMapRegions} from "../../../../components/coverageMap/CoverageMap.ts";
import Icon from "../../../../components/selfcare/Icon.tsx";
import Routing from "../../../../Routing.ts";
import CoverageMapContainer from "../../../../components/coverageMap/CoverageMapContainer.tsx";
import IconArrow from "../../../../components/icons/IconArrow.tsx";
import OrderAddressSearchComponent from "../../../../components/order/OrderAddressSearchComponent.tsx";
import {DispatchHighLightAddressSearchEvent} from "../../../../util/events.ts";

const questions_good_to_know: Question[] = [
    {
        question: "Kan jeg tage min 5G-router med i sommerhuset?",
        answer: <>
            <p>
                Ja, det kan du godt. Vi kan ikke garantere den samme hastighed på dit 5G-internet i sommerhuset, som på din bopæl. 
                Men så længe du tager din 5G-router og tilhørende strømstik med i dit sommerhus, kan du koble dig til routerens wifi.
            </p>
        </>
    },
    {
        question: <>Kan jeg have to internetabonnementer hos jer &ndash; på bopælsadressen og i sommerhuset?</>,
        answer: <>
            <p>
                Ja, du kan sagtens have to internetabonnementer hos os, på to forskellige adresser.
            </p>
        </>
    },
    {
        question: "Dækker I kun 5G-internet og ikke 4G-internet i sommerhusområder?",
        answer: <>
            <p>
                Vi sælger som udgangspunkt kun <a href={Routing.Broadband.TDC5G} rel={'nofollow'}>5G-internet</a> med minimum 100 Mbit i hastighed,
                alle steder i Danmark, så du er sikret den bedste forbindelse. Har du købt 5G-internet til din bolig, hvor du har fast bopæl 
                og ønsker at tage internettet med i dit sommerhus, hvor der kun er 4G, virker din 5G-router stadigvæk. 
                Vi kan ikke garantere en lige så god forbindelse i dit sommerhus, som på din bopæl.
            </p>
        </>
    },
    {
        question: "Kan jeg starte og stoppe mit internetabonnement i sommerhuset, alt efter hvornår jeg er der?",
        answer: <>
            <p>
                Nej, hvis du køber et særskilt internetabonnement kun til sommerhuset, kan du ikke starte og stoppe dit abonnement på bestemte tidspunkter.
                Men du kan altid tage dit 5G-internet, som du har købt på din bopæl med i sommerhuset.
            </p>
        </>
    },
    {
        question: "Hvordan får jeg internet i sommerhus?",
        answer: <>
            <p>
                Du skal ganske enkelt slå adressen på dit sommerhus op, og så kan du se dine muligheder:
            </p>
            <div className={'button-container'}>
                <button
                    className={'button button--montserrat with-icon teal'}
                    onClick={() => DispatchHighLightAddressSearchEvent(true)}
                >
                    <span className={'text'}>Tjek din adresse</span>
                    <Icon component={IconArrow} className={'icon-arrow-down'}/>
                </button>
            </div>
        </>
    },
    {
        question: "Hvad koster internet i sommerhus?",
        answer: <>
            <p>
                Hvis du køber 5G-internet til sommerhuset, kan du få det for 199,- de første 3 måneder, herefter 279,-.
                Hvis du ønsker at købe et <Link to={Routing.Broadband.Fiber}>fibernet</Link> abonnement til sommerhuset, er der andre priser end ved 5G-internet.
                Vi har ofte kampagner på vores forbindelser, afhængigt af adressen, som du kan se ved at lave et adresseopslag:
            </p>
            <div className={'button-container'}>
                <button
                    className={'button button--montserrat with-icon teal'}
                    onClick={() => DispatchHighLightAddressSearchEvent(true)}
                >
                    <span className={'text'}>Tjek din adresse</span>
                    <Icon component={IconArrow} className={'icon-arrow-down'}/>
                </button>
            </div>
        </>
    },
]

export default function SommerhusArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <h2>Få internet i sommerhuset</h2>
                    <div className="paragraph">
                        <p>
                            Når du tilbringer meget tid i dit sommerhus, er en stabil og hurtig internetforbindelse en nødvendighed for at kunne streame, 
                            arbejde, eller holde kontakten med familie og venner. Hos Hiper kan du både få <a href={Routing.Broadband.TDC5G}>5G-internet</a>, som vi dækker i 99,9% af
                            landet, <Link to={Routing.Broadband.Fiber}>fibernet</Link> eller <Link to={Routing.Broadband.Coax}>coax</Link> internet, hvis det er tilgængeligt på din adresse i sommerhuset.
                        </p>
                        <p>
                            <button
                                className={'link'}
                                onClick={() => DispatchHighLightAddressSearchEvent(true)}
                            >
                                Tjek adressen
                            </button>{' '}
                            på dit sommerhus for muligheder.
                        </p>
                    </div>
                    <img
                        className="paragraph-image mb0"
                        src={imageMap.help.subscription.sommerhus}
                        alt="Du kan få internet i dit sommerhus i hele landet."
                    />
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvorfor vælge internet til sommerhuset fra Hiper?</h2>
                        <p>
                            Hiper har en løsning til dig, som står og mangler en nem og hurtig måde at få 5G-internet på.
                            Du kan nemlig få et fast internet-abonnement i sommerhuset, så du altid er online, uanset hvor i landet dit sommerhus ligger.
                            De fleste vælger dog mobilt internet i sommerhuset, fordi det er lidt billigere,
                            nemmere og meget mere fleksibelt ift. kablede internetforbindelser.
                        </p>
                        <p> 
                            Hvis du allerede har købt 5G-internet fra os til din bopælsadresse, kan du sagtens tage det med dig i dit 
                            sommerhus, men du kan også købe et særskilt abonnement kun til sommerhuset.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Mobilt bredbånd i sommerhus &ndash; den nemme løsning</h2>
                        <p>
                            Ønsker du fleksibilitet, anbefaler vi mobilt bredbånd til sommerhuset. Med <Link to={Routing.Broadband.TDC5G}>5G-internet</Link> fra
                            Hiper kan du nemt tage internettet med dig &ndash; og så slipper du for <Link to={'/hjaelp/bestilling/fiber-installation'}>fibernet installation</Link>.
                            Vi dækker kun 5G-områder med mindst 100 Mbit i hastighed, så du er sikret den bedste forbindelse, men tjek din adresse for muligheder. 
                            Under alle omstændigheder er mobilt bredbånd i sommerhuset et godt og nemt valg &ndash; alt du skal gøre er at indsætte SIM-kortet i en 5G-router, tilslutte strøm, og så er du online!
                        </p>
                        <ul className="list list--bullet">
                            <p><strong>I dit mobile internetabonnement får du:</strong></p>
                            <li>Fri data</li>
                            <li>5G-hastigheder op til 1000 Mbit</li>
                            <li>Danmarks bedste 5G-dækning fra TDC NET</li>
                            <li>Nem installation</li>
                        </ul>
                    </div>
                    <img
                        className="paragraph-image mb0"
                        src={imageMap.help.subscription.router_i_stue}
                        alt="Lynhurtig 5G-router som kan bruges i dit sommerhus, så du altid har internet til rådighed."
                    />
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Fibernet sommerhus abonnement – ekstra stabilitet og hastighed</h2>
                        <p>
                            Vil du have ekstra stabilitet og lynhurtige hastigheder, så anbefaler vi <Link to={Routing.Broadband.Fiber}>fibernet</Link> i sommerhuset.
                            Især hvis du bruger dit sommerhus samt internetadgang rigtig hyppigt og meget. 
                            Fibernet giver dig en pålidelig forbindelse, hvor du kan streame film i høj kvalitet, game, have videomøder eller arbejde hjemmefra uden problemer. 
                        </p>
                        <ul className="list list--bullet">
                            <p><strong>Med vores fibernet sommerhus abonnement får du:</strong></p>
                            <li>En 100 Mbit eller 1000 Mbit hastighed</li>
                            <li>Mest stabile netværk til sommerhuset</li>
                            <li>Streaming uden afbrydelser på flere enheder</li>
                            <li>Perfekt internet til gaming</li>
                        </ul>
                    </div>
                </div>

                <div className="article">
                    <h2>Spørgsmål omkring bredbånd i sommerhus:</h2>
                    <QuestionAnswerComponent questions={questions_good_to_know}/>
                </div>

                <div className="article">
                    <h2>Se vores sommerhus-dækning</h2>
                    <p>
                        På vores dækningskort kan du se alle de områder, som vi kan tilbyde internetforbindelser til, 
                        sorteret på vores 5G-netværk samt fiber-netværker. Uanset hvor du har sommerhus i landet, kan du højst sandsynligt få en af forbindelserne fra os.
                        <button
                            className={'link'}
                            onClick={() => DispatchHighLightAddressSearchEvent(true)}
                        >
                            Tjek din adresse
                        </button>, så du kan få hurtigt internet i sommerhuset.
                    </p>
                    <p>
                        Vi dækker 5G-internet i stort set hele Danmark via TDC NET.
                        Alle de markerede områder på kortet forneden, dækker vi med 5G-internet.
                    </p>
                    <CoverageMapContainer regionPreset={BigCoverMapRegions.MBB} fiberMapOnly={false} static={true}/>
                    <p className="coverage-map-disclaimer">
                        Vi kan ikke garantere at kunne levere til alle adresser i de markerede områder.
                    </p>
                </div>

                <div className="article article--connect">
                    <div className="paragraph">
                        <p className="align-center">
                            På vores fiber-kort kan du se fiber-infrastrukturen i dit sommerhusområde.
                        </p>
                    </div>
                    <CoverageMapContainer regionPreset={ALL_FIBER} fiberMapOnly={true} static={false}/>
                    <p className="coverage-map-disclaimer">
                        Vi kan ikke garantere at kunne levere til alle adresser i de markerede områder.
                    </p>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <p>
                            Vil du også have <Link to={Routing.Broadband.Fiber}>lynhurtigt fibernet</Link>?
                            <button
                                className={'link'}
                                onClick={() => DispatchHighLightAddressSearchEvent(true)}
                            >
                                Tjek din adresse herunder
                            </button>{' '}
                            og se, hvad du kan&nbsp;få!
                        </p>
                        <OrderAddressSearchComponent/>
                    </div>
                </div>
            </article>

            <RelatedPagesComponent
                articles={[
                    {
                        "link": Routing.Broadband.TDC5G,
                        "name": "Bestil 5G-internet"
                    },
                    {
                        "link": Routing.Broadband.Fiber,
                        "name": "Bestil fibernet"
                    },
                    {
                        "link": Routing.Broadband.Coax,
                        "name": "Bestil coax internet"
                    },
                    {
                        "link": "/hjaelp/internet-og-wifi/hvilket-internet-skal-jeg-vaelge",
                        "name": "Hvilket Internet skal jeg vælge?"
                    }
                ]}
            />
        </>
    )
}
